module.exports = __webpack_public_path__ + "static/media/rs-solutions-computer.f549cbe6.png";